import React from 'react';
import { SummaryViewModel } from '../../ViewModel/summaryViewModel/summaryViewModel';
import { SummaryDataHooks } from './constants';
import { Text, TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { useCalendarActions } from '../../Hooks/useCalendarActions';
import { classes } from './Summary.st.css';
import { AccessibilityHtmlTags } from '../../../../utils/accessibility/constants';
import { EditSmall as EditIcon } from '@wix/wix-ui-icons-common';
import { useExperiments } from '@wix/yoshi-flow-editor';

export interface SummaryProps {
  viewModel: SummaryViewModel;
}

export const Summary: React.FC<SummaryProps> = ({ viewModel }) => {
  const { openServicesPreferencesModal } = useCalendarActions();
  const { experiments } = useExperiments();

  const {
    summary: { services, location, duration, addOnsCount },
    openPreferencesButton,
    isRescheduleFlow,
  } = viewModel;

  const isAddonsUOUEnabled = experiments.enabled('specs.bookings.AddonsUOU');

  return (
    <div data-hook={SummaryDataHooks.ROOT} className={classes.root}>
      <div className={classes.summary}>
        {!!services && (
          <Text
            tagName={AccessibilityHtmlTags.Paragraph}
            data-hook={SummaryDataHooks.SERVICES}
          >
            {services}
          </Text>
        )}

        {!!addOnsCount && isAddonsUOUEnabled && (
          <Text
            data-hook={SummaryDataHooks.ADDONS_COUNT}
            tagName={AccessibilityHtmlTags.Paragraph}
          >
            {addOnsCount}
          </Text>
        )}

        {!!duration && (
          <Text
            data-hook={SummaryDataHooks.DURATION}
            aria-label={duration.durationAriaText}
            tagName={AccessibilityHtmlTags.Paragraph}
          >
            {duration.durationText}
          </Text>
        )}

        <Text
          data-hook={SummaryDataHooks.LOCATION}
          tagName={AccessibilityHtmlTags.Paragraph}
        >
          {location}
        </Text>
      </div>

      {!isRescheduleFlow && (<TextButton
        data-hook={SummaryDataHooks.OPEN_PREFERENCES_BUTTON}
        aria-label={openPreferencesButton.ariaLabel}
        onClick={() => openServicesPreferencesModal()}
        priority={TextButtonPriority.primary}
        className={classes.openPreferencesModalButton}
        prefixIcon={<EditIcon />}
      >
        {openPreferencesButton.text}
      </TextButton>)}
    </div>
  );
};
